import {createStateMaker} from '@shared/helpers/object'

import {AffiliatePointStatus, APIStatus} from '@web/core/constants'

import {AffiliatePointState} from '../interfaces'

export const getInitialState = (): AffiliatePointState => ({
    status: AffiliatePointStatus.ENABLE,
    scene: APIStatus.IDLE,
    amount: 0,
    resultCode: null,
    message: null,
})

export const makeMock = createStateMaker<AffiliatePointState>(getInitialState)
